/**
 * DE: Reproduzierbarer Zufallsgenerator (mulberry32): gleicher Seed, gleiche Folge.
 * Liefert Werte im Bereich [0, 1).
 * EN: Reproducible random generator (mulberry32): same seed, same sequence.
 * Returns values in the range [0, 1).
 */
export function createRandom(seed: number): () => number {
  let state = seed >>> 0;
  return () => {
    state = (state + 0x6d2b79f5) >>> 0;
    let value = state;
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  };
}
